import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';
import { ApplicationConfigurationState } from './application-configuration.state';

function createInitialState(): ApplicationConfigurationState {
  return {};
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'application-configuration' })
export class ApplicationConfigurationStore extends Store<ApplicationConfigurationState> {
  constructor() {
    super(createInitialState());
  }
}
